export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-00.3def5209.jpg";